import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { get, capitalize } from 'lodash'
import { apiFetch, viewportWidth, viewportHeight, getYoutubeId, getVimeoId } from 'helpers'
import { Overlay, ActionSheets, SlideupView, ConfirmDialog } from 'components/Modal'
import { FormGroup, Input, Label, Button } from 'components/Form'
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import VideoItem from 'components/VideoItem'
import { List } from 'react-virtualized'
import Youtube from 'react-youtube'

import Section, { SectionHeader, SectionHeaderText, SectionHeaderCount, SectionHeaderRight, BtnAdd, SectionBody, SectionFooter, IconRight, ItemWrapper, BtnSquareAdd, getItemWrapperWidth } from './Section'

import svgMore from 'assets/svg/icon-more.svg'
import svgYoutube from 'assets/svg/icon-youtube.svg'
import svgVimeo from 'assets/svg/icon-vimeo.svg'
import svgPlusTiffany from 'assets/svg/icon-plus-tiffany.svg'
import svgRight from 'assets/svg/icon-right.svg'
import svgClose from 'assets/svg/icon-close.svg'

const limit = 36
const listVideoWidth = () => (Math.min(viewportWidth(), 480) - 20) / 3

@connect(state => ({
  loading: get(state, 'vendor.findVideosAttempting'),
  videoCount: get(state, 'vendor.videoCount') || 0,
  videos: get(state, 'vendor.videos') || [],
  hasMore: get(state, 'vendor.hasMoreVideos'),
  me: get(state, 'vendor.me'),
  removing: get(state, 'vendor.removeVideoAttempting')
}))
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menusVisible: false,
      adding: false
    }
  }

  componentDidMount () {
    const { dispatch } = this.props
    Promise.all([
      apiFetch({
        dispatch,
        key: 'COUNT_VIDEOS',
        v4: true,
        url: '/v4/vendors/me/videos/count'
      }),
      apiFetch({
        dispatch,
        key: 'FIND_VIDEOS',
        v4: true,
        url: '/v4/vendors/me/videos',
        query: { limit },
        actionParams: { clear: true, limit }
      })
    ])
  }

  _onAddVideo = () => {
    if (this.state.adding) return
    const { dispatch } = this.props
    this.setState({ adding: true, added: false }, () =>
      apiFetch({
        dispatch,
        method: 'POST',
        key: 'ADD_VIDEO',
        v4: true,
        url: '/v4/vendors/me/videos',
        body: { videoPath: this.state.videoPath }
      })
        .then(() => {
          dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'เพิ่มวิดีโอสำเร็จ' })
          this.setState({ adding: false, added: false, menusVisible: false, videoSource: '', videoPath: '' })
        })
        .catch(error => {
          dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'เพิ่มวิดีโอไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
          this.setState({ error, adding: false, added: false })
        })
    )
  }

  _rowRenderer = ({ key, index, style, className }) => {
    const { videos, dispatch, hasMore, loading } = this.props
    const colCount = 3
    const skip = (videos || []).length
    if (!loading && hasMore && ((skip - colCount * index) < limit / 2)) {
      apiFetch({
        dispatch,
        key: 'FIND_VIDEOS',
        v4: true,
        url: '/v4/vendors/me/videos',
        query: { skip, limit },
        actionParams: { limit }
      })
    }

    return (
      <Row key={key} className={className} style={style}>
        {index === 0 && (
          <VideoItemWrapper>
            <BtnSquareAdd title='เพิ่มวิดีโอ' width={listVideoWidth()} onClick={() => this.setState({ menusVisible: true, viewAll: false })} />
          </VideoItemWrapper>
        )}
        {(videos.slice(index * colCount, (index + 1) * colCount - (index === 0 ? 1 : 0))).map((video, index) =>
          <VideoItemWrapper key={index}>
            <VideoItem loading={this.props.loading}
              video={video} width={listVideoWidth}
              onClick={() => this.setState({ currentVideo: video })} />
          </VideoItemWrapper>
        )}
      </Row>
    )
  }

  _onRemoveVideo = () => {
    const { dispatch } = this.props
    apiFetch({
      dispatch,
      key: 'REMOVE_VIDEO',
      method: 'DELETE',
      v4: true,
      url: `/v4/vendors/me/videos/${get(this.state, 'currentVideo._id')}`
    })
      .then(() => {
        dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'ลบวิดีโอสำเร็จ' })
        this.setState({ confirmRemove: false, currentVideo: null })
      })
      .catch(() => {
        dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'ลบวิดีโอไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
      })
  }

  render () {
    const { loading, videoCount, videos, removing } = this.props
    const itemWrapperWidth = getItemWrapperWidth()
    return (
      <Section>
        <SectionHeader>
          <SectionHeaderText>วิดีโอ</SectionHeaderText>
          {!loading && <SectionHeaderCount>{videoCount} วิดีโอ</SectionHeaderCount>}
          <SectionHeaderRight>
            <BtnAdd onClick={() => this.setState({ menusVisible: true })}>
              <img alt='' src={svgPlusTiffany} />
              <span>เพิ่มวิดีโอ</span>
            </BtnAdd>
          </SectionHeaderRight>
        </SectionHeader>
        {(
          <SectionBody>
            {viewportWidth() > 767 && (
              <ItemWrapper desktop>
                <BtnSquareAdd width={itemWrapperWidth} title='เพิ่มวิดีโอ' onClick={() => this.setState({ menusVisible: true })} />
              </ItemWrapper>
            )}
            {(loading ? (Array(6).fill().map((_, index) => index)) : (videos || [])).map((video, index) =>
              <ItemWrapper showAll key={index} onClick={(index === 4 && (videos || []).length > 5) ? () => this.setState({ viewAll: true }) : null}>
                <VideoItem loading={loading} video={video} width={itemWrapperWidth}
                  onClick={() => this.setState({ currentVideo: video })} />
              </ItemWrapper>
            )}
          </SectionBody>
        )}
        <Overlay visible={this.state.menusVisible || this.state.videoSource || this.state.viewAll}
          onClose={() => this.setState({ menusVisible: false, videoSource: '', viewAll: false })}>
          <ActionSheets
            withoutOverlay
            visible={this.state.menusVisible}
            title='เลือกแหล่งที่มาของวิดีโอ'
            onCancel={() => this.setState({ menusVisible: false })}
            options={[
              { key: 'youtube', onClick: () => this.setState({ menusVisible: false, videoSource: 'youtube' }), title: 'Youtube', icon: svgYoutube },
              { key: 'vimeo', onClick: () => this.setState({ menusVisible: false, videoSource: 'vimeo' }), title: 'Vimeo', icon: svgVimeo }
            ]} />
          <SlideupView
            withoutOverlay
            viewType='tall'
            visible={this.state.videoSource}
            title={`เพิ่มวิดีโอจาก Link ${!this.state.videoSource ? '' : capitalize(this.state.videoSource)}`}
            onClose={() => this.setState({ videoSource: '' })}>
            <FormGroup>
              <Label>URL</Label>
              <Input type='text' value={this.state.videoPath}
                placeholder={this.state.videoSource === 'youtube'
                  ? 'https://www.youtube.com/watch?v=[youtubeId]'
                  : 'https://vimeo.com/[vimeoId]'}
                onChange={e => this.setState({ videoPath: e.target.value })} />
              <Button loading={this.state.adding} style={{ marginTop: 15 }} onClick={this._onAddVideo}>เพิ่มวิดีโอ</Button>
            </FormGroup>
          </SlideupView>
          <SlideupView viewType='full'
            withoutOverlay
            noPadding
            visible={this.state.viewAll}
            title={`วิดีโอทั้งหมด (${videoCount})`}
            onClose={() => this.setState({ viewAll: false })}>
            <List
              ref='_list'
              rowCount={Math.ceil((videos || []).length / 3)}
              style={{ paddingTop: 5 }}
              scrollToAlignment='start'
              scrollToIndex={Math.floor(this.state.currentIndex / 3)}
              rowRenderer={this._rowRenderer}
              rowHeight={listVideoWidth() + 55}
              width={Math.min(viewportWidth(), 480)}
              height={viewportHeight() - 56} />
          </SlideupView>
        </Overlay>
        <FullscreenVideo video={get(this.state, 'currentVideo')}
          onRemove={this._onRemoveVideo}
          removing={removing}
          onClose={() => this.setState({ currentVideo: null })} />
      </Section>
    )
  }
}

const Row = styled.div`
  width: calc(100% - 10px) !important;
  padding: 0px 5px;
`
const VideoItemWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: left;
  width: calc(33.33% - 4px);
  padding-bottom: calc(33.33% - 4px);
  margin-right: 5px;
  margin-bottom: 5px;
  &:nth-child(3n) { margin-right: 0px; }
`

class FullscreenVideo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menusVisible: false,
      confirmVisible: false
    }
  }

  componentWillReceiveProps (nextProps) {
    const path = 'video._id'
    if (get(this.props, path) !== get(nextProps, path)) {
      this.setState({ menusVisible: false, confirmVisible: false })
    }
  }

  render () {
    const { video, onClose, onRemove, removing } = this.props
    const youtubeId = getYoutubeId(get(video, 'videoPath'))
    const vimeoId = getVimeoId(get(video, 'videoPath'))
    const vw = Math.min(1080, viewportWidth())
    const videoOpts = {
      width: vw,
      height: (vw * 9 / 16)
    }

    return (
      <FullscreenVideoWrapper visible={get(video, '_id')}>
        <HorizontalCentered>
          <VerticalCentered>
            <div>
              {youtubeId ? (
                <Youtube
                  videoId={youtubeId}
                  opts={videoOpts} />
              ) : vimeoId ? (
                <iframe title='vimeo' src={`https://player.vimeo.com/video/${vimeoId}?color=f0262a`}
                  {...videoOpts} frameborder='0'
                  webkitallowfullscreen='true'
                  mozallowfullscreen='true'
                  allowFullScreen />
              ) : null}
            </div>
          </VerticalCentered>
        </HorizontalCentered>
        <BtnClose onClick={onClose}>
          <IconClose src={svgClose} />
        </BtnClose>
        <BtnMore>
          <IconMore src={svgMore} onClick={() => this.setState({ menusVisible: !this.state.menusVisible })} />
          <ActionSheets
            topRight
            withoutOverlay={viewportWidth() > 768}
            visible={this.state.menusVisible}
            onCancel={() => this.setState({ menusVisible: false })}
            options={[
              { key: 'remove', title: 'ลบวิดีโอ', color: 'colorCoral', onClick: () => this.setState({ confirmVisible: true }) }
            ]} />
        </BtnMore>
        <Overlay visible={this.state.confirmVisible}
          onClose={() => this.setState({ confirmVisible: false })}>
          <ConfirmDialog title='คุณต้องการลบวิดีโอนี้ ?'
            loading={removing}
            onOkay={onRemove}
            onCancel={() => this.setState({ confirmVisible: false })} />
        </Overlay>
      </FullscreenVideoWrapper>
    )
  }
}

const FullscreenVideoWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: black;
  transition: opacity 0.3s ease;
  ${props => props.visible ? `
    opacity: 1;
    z-index: 16000;
  ` : `
    opacity: 0;
    z-index: -1;
  `}
`
const BtnClose = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
`
const IconClose = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 12px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`
const BtnMore = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
`
const IconMore = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 12px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`



// WEBPACK FOOTER //
// ./src/components/profile/SectionVideos.js